"use client";
import React, { useRef } from "react";
import { useScroll, useTransform, motion, MotionValue } from "motion/react";

export const ContainerScroll = ({
    children,
    imageUrl,
}: {
    children: React.ReactNode;
    imageUrl: string; // Added imageUrl prop
}) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const { scrollYProgress } = useScroll({
        target: containerRef,
    });
    const [isMobile, setIsMobile] = React.useState(false);

    React.useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => {
            window.removeEventListener("resize", checkMobile);
        };
    }, []);

    const scaleDimensions = () => {
        return isMobile ? [0.8, 0.9] : [1.05, 1];
    };

    const rotate = useTransform(scrollYProgress, [0, 0.2], [10, 0]);
    const scale = useTransform(scrollYProgress, [0, 0.2], scaleDimensions());
    const translate = useTransform(scrollYProgress, [0, 0.2], [0, -60]);
    

    return (
        <div
            className="h-[60rem]
        
             flex items-center justify-center relative p-2 md:p-20"
            ref={containerRef}
            style={{
                marginTop: isMobile ? '-470px' : '0px', 
            }}
        >
            <div
                className=" w-full relative"
                style={{
                    perspective: "1000px",
                }}
            >
                <Card
                    rotate={rotate}
                    translate={translate}
                    scale={scale}
                    isMobile={isMobile}
                    imageUrl={imageUrl} // Passing imageUrl to Card
                >
                    {children}
                </Card>
            </div>
        </div>
    );
};

export const Header = ({ translate, titleComponent }: any) => {
    return (
        <motion.div
            style={{
                translateY: translate,
            }}
            className="div max-w-5xl mx-auto text-center"
        >
            {titleComponent}
        </motion.div>
    );
};

export const Card = ({
    rotate,
    scale,
    translate,
    imageUrl,
    children,
    isMobile,
}: {
    rotate: MotionValue<number>;
    scale: MotionValue<number>;
    translate: MotionValue<number>;
    imageUrl: string; // Accepting imageUrl as a prop
    children: React.ReactNode;
    isMobile: boolean;
}) => {
    return (
        <motion.div
            style={{
                rotateX: rotate,
                scale,

            }}
            className=""
        >
            <div className="h-full w-full flex items-center justify-center overflow-hidden">
                {imageUrl && (
                    <img
                        src={imageUrl}
                        alt="Card Visual"
                        className={`w-full ${isMobile ? "h-[55vh]" : "h-[200%]"} object-cover`}
                    />
                )}
                {children}
            </div>
        </motion.div>
    );
};

export default ContainerScroll;